export default `
  query getCurrentUser {
    getCurrentUser {
      id
      email
      firstname
      lastname
      company
      phoneNumber
      job
      registrationDate
      lastLogin
      loginCounter
      hasMcpApiKey
      apiKeyExpiresAt
      aiProviderKeys {
        provider
        mask
        status
      }
      picture {
        name
        url
        file {
          region
          bucket
          key
        }
        mimeType
      }
      githubAccounts {
        login
        avatar
      }
    }
  }
`
